var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{attrs:{"id":"modal-coupon","size":"xl","title":"Pilih Kupon","hide-footer":""}},[_c('Table',{attrs:{"isModal":true},on:{"chooseCoupon":_vm.chosenCoupon}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }